// perspective types
import { PerspectiveType } from '../../types';

export const ENGAGEMENT = 'ENGAGEMENT';
export const WORKFLOW = 'WORKFLOW';
export const FORM = 'FORM';

interface PerspectiveDetails {
  urlResource: string,
}

export const PERSPECTIVE_DETAILS_BY_PERSPECTIVE_TYPE: Record<PerspectiveType, PerspectiveDetails> = {
  [ENGAGEMENT]: {
    urlResource: 'engagements',
  },
  [WORKFLOW]: {
    urlResource: 'workflows'
  },
  [FORM]: {
    urlResource: '',
  },
};

// Used in event.dataTransfer onDrop events
export const WIDGET_TYPE = 'WIDGET_TYPE';
export const FIELD_ID = 'FIELD_ID';
export const PERSPECTIVE_ID = 'PERSPECTIVE_ID';

// Widget types
export const WIDGET_TEXT = 'TEXT';
export const TABLE = 'TABLE';
export const CALENDAR = 'CALENDAR';
export const STEPPER = 'STEPPER';
export const ROLE_ASSIGNMENTS = 'ROLE_ASSIGNMENTS';
export const ACTIVITY_LOG = 'ACTIVITY_LOG';
